import { evalBinding } from "../../lib/bindings";

export default function TextBlock({ block, data }: any) {
  const text = evalBinding(block.content, data) ?? "";
  const cls = block.className || "";

  if (block.href) {
    if (block.action === "print") {
      return (
        <button type="button" className={cls} disabled data-pdf-hide="true"
          aria-label={`${text}: use authenticated Report Actions to print`}
          title="Use authenticated Report Actions to print.">
          {text}
        </button>
      );
    }

    return (
      <a
        href={block.href}
        className={cls}
      >
        {text}
      </a>
    );
  }

  const Tag =
    block.variant === "h1" ? "h1" :
    block.variant === "h2" ? "h2" :
    block.variant === "caption" ? "div" : "div";

  return <Tag className={cls}>{text}</Tag>;
}
